import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  UserAccessConfigListResponse,
  UserAccessConfigResponse,
  CreateUserAccessConfigPayload,
  UpdateUserAccessConfigPayload,
} from "~/types/admin/auth";

class AdminUserAccessConfigModule extends HttpFactory {
  async getUserAccessConfigs(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<UserAccessConfigListResponse>> {
    return await this.get(
      `${ENDPOINTS.ADMIN.AUTH.USER_ACCESS_CONFIGS}`,
      fetchParams,
    );
  }

  async getUserAccessConfig(
    configId: string | number,
  ): Promise<UserAccessConfigResponse> {
    return await this.get(
      `${ENDPOINTS.ADMIN.AUTH.USER_ACCESS_CONFIGS}${configId}/`,
    );
  }

  async createUserAccessConfig(
    payload: CreateUserAccessConfigPayload,
  ): Promise<UserAccessConfigResponse> {
    return await this.post(
      `${ENDPOINTS.ADMIN.AUTH.USER_ACCESS_CONFIGS}`,
      payload,
    );
  }

  async updateUserAccessConfig(
    configId: string | number,
    payload: UpdateUserAccessConfigPayload,
  ): Promise<UserAccessConfigResponse> {
    return await this.patch(
      `${ENDPOINTS.ADMIN.AUTH.USER_ACCESS_CONFIGS}${configId}/`,
      payload,
    );
  }

  async deleteUserAccessConfig(configId: string | number): Promise<void> {
    return await this.delete(
      `${ENDPOINTS.ADMIN.AUTH.USER_ACCESS_CONFIGS}${configId}/`,
    );
  }
}

export { AdminUserAccessConfigModule };
